import * as React from "react";
const defaults = {
  localizations: null,
  setLocalizations: () => void 0,
  setLocale: () => void 0,
  formatDate: () => "",
  formatDateTime: () => "",
  formatDateString: () => "",
  formatNumber: () => "",
  formatCurrency: () => "",
  formatText: () => "",
  getWeekData: () => ({ firstDay: "" }),
  getDatePlaceholder: () => "",
  parseLocalDateString: () => /* @__PURE__ */ new Date(NaN),
  getLocaleDateFormat: () => {
    return {};
  }
};
export const LocalizationContext = React.createContext(defaults);
export const useLocalization = () => React.useContext(LocalizationContext);
